



import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './EmployeeAttendanceReport.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDistrict, getProject, getStates, getEmployeSatateAndDistrictWise, gettingAttendaceEmployeeWise } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter, convertToIST } from '../../../utils/validations';
import { format } from 'date-fns';
const EmployeeAttendanceReport = () => {
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [employeeOptions, setEmployeeoptions] = useState([]);
    const [employee, setemployee] = useState(null);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null)
    const [attendanceData, setAttendanceData] = useState([]);

    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        employee: false,
        fromDate: false,
        toDate: false,

    });
    const [errors, setErrors] = useState({});
    const yearInputRef = useRef(null);
    const [designationData, setDesignationData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const isFetchDataEnabled = state && district && fromDate && toDate && employee



    useEffect(() => {
        const fetchStates = async () => {
            try {
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);




    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {

                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };

            fetchDistricts();

        } else {
            setDistrictOptions([]);
            setDistrict(null);
        }
    }, [state]);


    useEffect(() => {
        if (district) {
            const fetchingEmployees = async () => {
                try {
                    const data = await getEmployeSatateAndDistrictWise(state, district);
                    setEmployeeoptions(
                        data.map(emp => ({
                            value: emp.employeeUniqueId,
                            label: emp.employeeName,
                        }))
                    )

                }
                catch (error) {
                    console.log("District or sate missing", error)
                }
            }
            fetchingEmployees()
        }
    }, [district])

    // Clear attendance data and fetch status when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);
        // setOriginalData([]);
        setHasFetched(false);
    }, [state, district,]); // ✅ Add project to depende

    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);


                break;
            case 'district':
                setDistrict(value);
                // setProject(null); // ✅ Clear project when district changes
                break;
            case 'employee':
                setemployee(value);

                // setProjectResponse([]);
                // setEmployees([]);
                // setEmployeeData([]);
                break;

            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };



    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        if (!district) newErrors.district = 'District is required';
        // if (!month) newErrors.month = 'Month is required';
        // if (!year) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            // FIX: Pass arguments individually, not as an object
            const data = await gettingAttendaceEmployeeWise(
                state,      // stateId
                district,   // districtId
                employee,   // employee
                fromDate,   // fromDate
                toDate      // toDate
            );

            // Update state with the nested attendance array from your JSON
            if (data && data.attendance) {
                setAttendanceData(data.attendance.filter(entry => Object.keys(entry).length > 0));
            }
        } catch (error) {
            console.error("Error fetching report data:", error);
            // ... error handling
        }
    };







    return (
        <div className="employee-report-container">
            <div className="employee-report-box">
                <h2 className="employee-report-heading">Employee Attendance Report</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}
                >
                    <div className="employee-report-maincontainer">
                        <div className="employee-report-container-part">
                            <div className={`employee-report-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="employee-report-container-part">
                            <div className={`employee-report-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>Working District</label>
                                {errors.district && <div className="error-message">{errors.district}</div>}
                            </div>
                        </div>
                    </div>

                    <div className="employee-report-maincontainer">
                        <div className="employee-report-container-part">
                            <div className={`employee-report-floating-label-container ${isFocused.employee || employee ? 'float-label' : ''}`}>
                                <Select
                                    name='employee'
                                    options={employeeOptions}
                                    value={employeeOptions.find(opt => opt.value === employee) || null}
                                    onChange={option => handleInputChange(option, 'employee')}

                                />
                                <label> <span className="required">*</span>Employee</label>

                            </div>

                        </div>

                        <div className="employee-report-container-part">
                            <div className={`employee-report-floating-label-container ${isFocused.fromDate || fromDate ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={fromDate}
                                    onChange={(date) => setFromDate(date)}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, fromDate: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, fromDate: false }))}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText=""
                                    className="employee-report-date-picker"
                                    // minDate={minDate}
                                    maxDate={new Date()}
                                    ref={yearInputRef}

                                    title="Select a year"
                                />
                                <label><span className="required">*</span>From Date</label>

                            </div>
                        </div>

                    </div>


                    <div className="employee-report-maincontainer">

                        <div className="employee-report-container-part">
                            <div className={`employee-report-floating-label-container ${isFocused.toDate || toDate ? 'float-label' : ''}`}>


                                <DatePicker
                                    selected={toDate}
                                    onChange={(date) => setToDate(date)}
                                    dateFormat='dd-MM-yyyy'
                                    className="employee-report-date-picker"
                                    minDate={fromDate}
                                />
                                <label><span className="required">*</span>To Date</label>
                            </div>
                        </div>
                        <div className="employee-report-container-part">
                            <div className="employee-report-btn-div">
                                <button type="submit" className="employee-report-btn"
                                    disabled={!isFetchDataEnabled}


                                >
                                    Generate Report
                                </button>
                            </div>
                        </div>

                    </div>


                </form>
            </div>


            <div className="report-table-monthlt-att-container">



                <table className="report-table-monthlt-att">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Attendance Date	</th>
                            <th>Attendance Status</th>
                            <th>Attendance Time</th>
                            <th>Working Location</th>
                            <th>Location Status</th>
                            <th>Remarks</th>
                            <th>Attendance Photo</th>

                        </tr>
                    </thead>
                    <tbody>
                        {attendanceData.length > 0 ? (
                            attendanceData.map((row, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    
                                    <td>{format(row.attendanceDate, 'dd-MM-yyyy')}</td>
                                    <td>{row.status}</td>
                                    {/* <td>{row.attendanceTime? format(new Date(`1970-01-01T${row.attendanceTime}`), 'HH:mm'): "-"}</td> */}
                                   <td> {row.attendanceTime? convertToIST(row.attendanceDate, row.attendanceTime): "-"}</td>
                                    <td>{row.workLocationName || "-"}</td>
                                    <td>{row.workLocation ? "In Location" : "Outside"}</td>
                                    <td>{row.auditRemarks?.join(", ") || "No Remarks"}</td>
                                    <td>
                                        {row.selfieUrl ? (
                                            <a href={row.selfieUrl} target="_blank" rel="noreferrer">View Photo</a>
                                        ) : "No Photo"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" style={{ textAlign: "center" }}>No attendance data available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>


        </div>
    );
};

export default EmployeeAttendanceReport;